// Updated TradeList with Fiat Edit & Map/Unmap Referral functionality
import React, { useEffect, useState } from "react";
import AuthService from "../../../api/services/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../customComponent/CustomAlertMessage";
import TraderDetails from "../TraderDetails";
import moment from "moment";
import LoaderHelper from "../../../customComponent/Loading/LoaderHelper";
import DataTableBase from "../../../customComponent/DataTable";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Select from "react-select";

const TradeList = () => {
  const [activeScreen, setActiveScreen] = useState("userdetail");
  const [userId, setUserId] = useState("");
  const [exportData, setExportData] = useState([]);
  const [traderData, settraderData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalData, setTotalData] = useState();
  const [search, setSearch] = useState("");
  const [kycType, setKycType] = useState(4);

  const [sponseredId, setsponseredId] = useState("");
  const userType = sessionStorage.getItem("userType");

  const [editFiatUserId, setEditFiatUserId] = useState(null);
  const [selectedFiats, setSelectedFiats] = useState([]);

  const [editUserType, setEditUserType] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState(null);

  const [mapReferralUserId, setMapReferralUserId] = useState(null);
  const [newReferralCode, setNewReferralCode] = useState("");

  const [packageList, setPackageList] = useState([]);
  const [packageSubscriptionDate, setPackageSubscriptionDate] = useState(new Date());
  const [botSubcriptionUserId, setBotSubcriptionUserId] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState({});
  
  // Investment details states
  const [affiliatePackageList, setAffiliatePackageList] = useState([]);
  const [investmentsList, setInvestmentsList] = useState([]);
  const [selectedInvestmentForEdit, setSelectedInvestmentForEdit] = useState(null);
  const [uplinesList, setUplinesList] = useState([]);
  const [currency, setCurrency] = useState("INR");
  const [planId, setPlanId] = useState("");
  const [showInvestmentDetails, setShowInvestmentDetails] = useState(false);
  const [referralJustMapped, setReferralJustMapped] = useState(false);
  console.log("🚀 ~ TradeList ~ selectedPackage:", selectedPackage)
  console.log("🚀 ~ TradeList ~ botSubcriptionUserId:", botSubcriptionUserId)
  console.log("🚀 ~ TradeList ~ packageSubscriptionDate:", packageSubscriptionDate)
  console.log("🚀 ~ TradeList ~ packageList:", packageList)

  const fiatOptions = ["INR", "USD", "EURO", "AED"].map((c) => ({ value: c, label: c }));

  const handlePageChange = ({ selected }) => setCurrentPage(selected + 1);
  const pageCount = totalData / itemsPerPage;
  const skip = (currentPage - 1) * itemsPerPage;

  const linkFollow = (row) => (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex flex-wrap gap-2">
        <button className="btn btn-dark btn-sm" onClick={() => { settraderData(row); setUserId(row?._id); setActiveScreen("detail") }}>View</button>
        <button className={`btn btn-sm ${row?.status === 'Active' ? 'btn-success' : 'btn-danger'}`} onClick={() => handleStatus(row?.id, row?.status === 'Active' ? 'Inactive' : 'Active')}>
          {row?.status === 'Active' ? 'Active' : 'Inactive'}
        </button>
        <button className="btn btn-warning btn-sm" onClick={() => {
          setEditFiatUserId(row?._id);
          setSelectedFiats((row?.allowed_fiat_currencies || []).map(f => ({ value: f, label: f })));
        }}>Edit Fiat</button>
        
      </div>

    </div>
  );

  const linkFollowMapUnmap = (row) => (

    <div className="d-flex flex-column gap-2">
      <button className="btn btn-outline-primary btn-sm" onClick={async () => {
        setMapReferralUserId(row._id);
        setsponseredId(row?.sponsered_by?.emailId);
        setNewReferralCode("");
        setSelectedInvestmentForEdit(null);
        setReferralJustMapped(false);
        
        // Load investments by default
        LoaderHelper.loaderStatus(true);
        try {
          const result = await AuthService.loadInvestments(row._id);
          if (result.success) {
            setInvestmentsList(result?.affiliateInvestments || []);
            setShowInvestmentDetails(true);
          }
        } catch {
          alertErrorMessage("Failed to fetch investments");
        } finally {
          LoaderHelper.loaderStatus(false);
        }
      }}>{row?.sponsered_by ? "Mapped" : "Map Referral"}</button>
      <button className="btn btn-outline-danger btn-sm" onClick={() => unmapReferral(row._id)}>Unmap</button>
    </div>
  );

  const userIdFollow = (row) => row._id

  const linkFollow2 = (row) => (
    <div className="d-flex flex-column justify-content-center align-items-center gap-1 my-3">
      <div>{row?.affiliate_status ? "Active" : "Inactive"}</div>
      <div>
        <button className={`btn btn-sm ${row?.affiliate_status ? 'btn-success' : 'btn-danger'}`} onClick={() => updateAffiliateStatus(row?.id, !row?.affiliate_status)}>
          {row?.affiliate_status ? "Active" : "Inactive"}
        </button>
      </div>
    </div>
  );

  const modifiacation = (row) => (
    <div className="d-flex flex-column gap-2">
      <button className="btn btn-dark btn-sm" >Modify FIPCOIN</button>
    </div>
  )

  const Subscription = (row) => (
    <div className="d-flex flex-column gap-2">
      <button className="btn btn-dark btn-sm" onClick={() => {
        resetBotSubscriptionInput();
        setBotSubcriptionUserId(row._id);
      }}>Add Bot Subscription</button>
      <button className="btn btn-primary btn-sm" onClick={() => {
          setSelectedUserType(row?.userType);
          setEditUserType(row?._id);
        }}>User Type ({row?.userType.toUpperCase()})</button>
    </div>
  )

  const columns = [
    { name: "Sr No.", selector: (row, index) => skip + index + 1 },
    // { name: "User ID", wrap: true, selector: userIdFollow },
    // { name: "Hear About Us", wrap: true, selector: row => row.hear_about_us || "Existing Investor" },
    { name: "Name", wrap: true, selector: row => row?.firstName + " " + row?.lastName || "-----" },
    { name: "Email", wrap: true, selector: row => row.emailId || "-----" },
    { name: "Referral Code", wrap: true, selector: row => row.referral_code || "-----" },
    { name: "KYC", wrap: true, selector: row => ["Not Submitted", "Pending", "Approved", "Rejected"][row.kycVerified] },
    { name: "Phone", wrap: true, selector: row => row.mobileNumber || "-----" },
    { name: "Reg. Date", wrap: true, selector: row => moment(row?.registeredDate).format("MMM Do YYYY hh:mm A") },
    { name: "Sponsor Email", wrap: true, selector: row => row?.sponsered_by?.emailId || "-----" },
    // { name: "Subscription", width: "180px", selector: Subscription },
    { name: "Map / Unmap", wrap: true, selector: linkFollowMapUnmap, width: "150px" },
    { name: "Affiliate", selector: linkFollow2 },
    { name: "Action", selector: linkFollow }
  ];



  const handlePackageList = async () => {
    try {
      LoaderHelper.loaderStatus(true);
      const result = await AuthService.getPackageList();
      LoaderHelper.loaderStatus(false);
      if (result?.success) {
        const data = result?.data?.filter((item) => item?.status === "ACTIVE")
        const listData = data.map((c) => (
          {
            value: c._id, label: `${c.name.trim()} | ₹${c.price} + GST | Valid: ${c.validityDays} days`
          }
        ));
        setPackageList(listData);
      } else {
        alertErrorMessage(result?.message || "Failed to fetch package list.");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      alertErrorMessage("Error fetching package list.");
    }
  };

  const subscribeToBotPackage = async () => {
    try {
      if (Object.keys(selectedPackage)?.length <= 0) {
        alertErrorMessage("Please selecet bot package");
        return
      }
      if (!packageSubscriptionDate) {
        alertErrorMessage("Please selecet bot subscription date");
        return
      }
      LoaderHelper.loaderStatus(true);
      const result = await AuthService.buyArbitrageBot(selectedPackage?.value, botSubcriptionUserId, packageSubscriptionDate);
      LoaderHelper.loaderStatus(false);
      if (result?.success) {
        resetBotSubscriptionInput();
        alertSuccessMessage("Subscription updated successfully")
      } else {
        alertErrorMessage(result?.message || "Failed to subscribing bot");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      alertErrorMessage("Error subscribing bot");
    }
  };

  const resetBotSubscriptionInput = () => {
    setSelectedPackage({});
    setPackageSubscriptionDate(new Date());
    setBotSubcriptionUserId(null)
  }

  useEffect(() => {
    handlePackageList();
    fetchAffiliatePackageList();
  }, []);

  const fetchAffiliatePackageList = async () => {
    try {
      const result = await AuthService.allPackageList();
      if (result.success) {
        setAffiliatePackageList(result?.data[0] || []);
      }
    } catch {
      alertErrorMessage("Failed to fetch affiliate packages");
    }
  };

  const loadInvestments = async (userId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.loadInvestments(userId);
      if (result.success) {
        setInvestmentsList(result?.affiliateInvestments || []);
      }
    } catch {
      alertErrorMessage("Failed to fetch investments");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };


  const handleStatus = async (_id, status) => {
    if (userType !== "1") {
      alertErrorMessage("Not Authorized");
      return;
    }

    const res = await AuthService.updateStatus(_id, status);
    if (res.success) {
      alertSuccessMessage(res.message);
      handleUserData(skip, itemsPerPage, search);
    } else {
      alertErrorMessage(res.message);
    }
  };

  const updateAffiliateStatus = async (_id, status) => {
    if (userType !== "1") {
      alertErrorMessage("Not Authorized");
      return;
    }

    const res = await AuthService.updateAffiliateStatus(_id, status);
    if (res.success) {
      alertSuccessMessage(res.message);
      handleUserData(skip, itemsPerPage, search);
    } else {
      alertErrorMessage(res.message);
    }
  };

  const handleUserData = async (skip, limit, search) => {
    LoaderHelper.loaderStatus(true);
    const res = await AuthService.getUserList(skip, limit, search, kycType);
    LoaderHelper.loaderStatus(false);
    if (res.success) {
      setExportData(res.data);
      setTotalData(res.totalCount);
    } else alertErrorMessage("No data found");
  };

  const handleSaveFiatUpdate = async () => {
    const res = await AuthService.updateAllowedFiat({ userId: editFiatUserId, currencies: selectedFiats.map(f => f.value) });
    if (res.success) {
      alertSuccessMessage("Fiat updated");
      setEditFiatUserId(null);
      handleUserData(skip, itemsPerPage, search);
    } else alertErrorMessage(res.message);
  };

  const handleSaveUserTypeUpdate = async () => {
    const res = await AuthService.updateUserType({ userId: editUserType, userType: selectedUserType?.value});
    if (res.success) {
      alertSuccessMessage("User Type updated");
      setEditUserType(null);
      handleUserData(skip, itemsPerPage, search);
    } else alertErrorMessage(res.message);
  };

  const userTypeOptions = [
    { value: "investor", label: "Investor" },
    { value: "ambassador", label: "Ambassador" },
    { value: "investor-ambassador", label: "Investor-Ambassador" },
    { value: "regular", label: "Regular" },
  ];

  const unmapReferral = async (userId) => {
    try {
      const res = await AuthService.unmapReferral({ userId });
      if (res.success) {
        alertSuccessMessage(res.message);
        handleUserData(skip, itemsPerPage, search);
      } else {
        alertErrorMessage(res.message);
      }
    } catch (error) {

    }
  };


  const mapReferral = async () => {
    if (!newReferralCode) return alertErrorMessage("Referral code required");
    
    LoaderHelper.loaderStatus(true);
    const res = await AuthService.mapReferral({ userId: mapReferralUserId, referralCode: newReferralCode });
    
    if (res.success) {
      alertSuccessMessage(res.message);
      setReferralJustMapped(true);
      setsponseredId(newReferralCode);
      
      // Reload investments after successful mapping
      try {
        const res = await AuthService.updateAllInvestmentROI({ userId: mapReferralUserId });
        if (res.success) {
          console.log("🚀 ~ updateAllInvestmentROI success:", res.message);
        
          const result = await AuthService.loadInvestments(mapReferralUserId);
          if (result.success) {
            const investments = result?.affiliateInvestments || [];
            setInvestmentsList(investments);
            setShowInvestmentDetails(true);

            // Get uplines for the mapped user
            const response = await AuthService.getUplines(mapReferralUserId);
            // console.log("🚀 ~ getUplines response:", response);
            // let uplines = [];
            // if (response.success) {
            //   uplines = response.uplines || [];
            //   console.log("🚀 ~ uplines:", uplines);
            //   setUplinesList(uplines);
            // }

            // Auto-select first investment if available
            if (investments.length > 0) {
              const firstInv = investments[0];
              setSelectedInvestmentForEdit({
                id: firstInv._id,
                roi_distribution: firstInv.roi_distribution || [],
              });
            }
          }
        }
      } catch {
        alertErrorMessage("Failed to fetch investments");
      }
      
      handleUserData(skip, itemsPerPage, search);
    } else {
      alertErrorMessage(res.message);
    }
    
    LoaderHelper.loaderStatus(false);
  };



  useEffect(() => {
    handleUserData(skip, itemsPerPage, search);
  }, [currentPage, itemsPerPage, skip, kycType, search]);

  return activeScreen === "userdetail" ? (
    <div id="layoutSidenav_content">
      <div className="container-xl px-4">
        <h1 className="mt-4 mb-3">Traders List</h1>
        <div className="card mb-4">
          <div className="card-header d-flex justify-content-between">
            <input type="search" className="form-control w-25" placeholder="Search email..." onChange={e => setSearch(e.target.value)} value={search} />
            <select className="form-select w-25" value={kycType} onChange={e => setKycType(e.target.value)}>
              <option value={2}>Approved KYC</option>
              <option value={1}>Pending KYC</option>
              <option value={3}>Rejected KYC</option>
              <option value={0}>Not Submitted</option>
              <option value={4}>All</option>
            </select>
          </div>
          <div className="card-body">
            <DataTableBase columns={columns} data={exportData} pagination={false} />
            <ReactPaginate pageCount={pageCount} onPageChange={handlePageChange} containerClassName={'customPagination'} activeClassName={'active'} />
          </div>
        </div>

        {editUserType && (
          <div className="modal d-block" style={{ background: "#000000a6" }}>
            <div className="modal-dialog">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5 className="modal-title">Edit User Type</h5>
                  <button className="btn-close" onClick={() => setEditUserType(null)}></button>
                </div>
                <div className="modal-body">
                  <Select styles={{ control: (base) => ({ ...base, borderColor: 'gray' }), option: (base) => ({ ...base, color: 'black' }) }} options={userTypeOptions} value={userTypeOptions.find(option => option.value === selectedUserType)} onChange={setSelectedUserType} />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setEditUserType(null)}>Cancel</button>
                  <button className="btn btn-primary" onClick={handleSaveUserTypeUpdate}>Save</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {editFiatUserId && (
          <div className="modal d-block" style={{ background: "#000000a6" }}>
            <div className="modal-dialog">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Fiat Currencies</h5>
                  <button className="btn-close" onClick={() => setEditFiatUserId(null)}></button>
                </div>
                <div className="modal-body">
                  <Select isMulti options={fiatOptions} value={selectedFiats} onChange={setSelectedFiats} />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setEditFiatUserId(null)}>Cancel</button>
                  <button className="btn btn-primary" onClick={handleSaveFiatUpdate}>Save</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {mapReferralUserId && (
          <div className="modal d-block" style={{ background: "#000000a6" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5 className="modal-title">{sponseredId ? `Mapped to ${sponseredId}` : "Map to Referral Code"}</h5>
                  <button className="btn-close" onClick={() => {
                    setMapReferralUserId(null);
                    setSelectedInvestmentForEdit(null);
                    setInvestmentsList([]);
                    setShowInvestmentDetails(false);
                  }}></button>
                </div>
                <div className="modal-body">
                  {!sponseredId && !referralJustMapped ? (
                    <div className="d-flex mb-3 align-items-center flex-column">
                      <input 
                        type="text" 
                        className="form-control mb-3" 
                        placeholder="Enter referral code" 
                        value={newReferralCode} 
                        onChange={e => setNewReferralCode(e.target.value)} 
                      />
                      <div className="gap-2 d-flex">
                        <button className="btn btn-primary" onClick={mapReferral}>Map Referral</button>
                      </div>
                    </div>
                  ) : (
                    <div className="alert alert-success mb-3">
                      <strong>Referral Mapped:</strong> {sponseredId}
                    </div>
                  )}
                  
                  {showInvestmentDetails && sponseredId && (<div className="border-top pt-3">
                    
                    {/* Select Investment Dropdown */}
                    <div className="form-group mb-3">
                      <label>Select Investment & Update ROI Distribution</label>
                      <select 
                        className="form-select form-control"
                        value={selectedInvestmentForEdit?.id || ''}
                        onChange={(e) => {
                          const selectedInv = investmentsList.find(inv => inv._id === e.target.value);
                          if (selectedInv && referralJustMapped) {
                            setSelectedInvestmentForEdit({
                              id: selectedInv._id,
                              roi_distribution: selectedInv?.roi_distribution || [],
                            });
                          } else {
                            // setSelectedInvestmentForEdit(null);
                            if(sponseredId){
                              setSelectedInvestmentForEdit({
                                id: selectedInv._id,
                                roi_distribution: selectedInv.roi_distribution?.map(up => ({
                                  level: up.level,
                                  user: up.user,
                                  roi_percent: up.roi_percent,
                                  userDetails: up.userDetails
                                })) || [],
                              });
                            }
                            
                          }
                        }}
                      >
                        <option value="" className="text-muted">Select an investment</option>
                        {investmentsList && investmentsList.length > 0 ? (
                          investmentsList.map((inv, idx) => {
                            const amount = typeof inv.amount === 'object'
                              ? parseFloat(inv.amount?.$numberDecimal || 0)
                              : parseFloat(inv.amount || 0);
                            const planName = inv.planDetails?.type || 'N/A';
                            
                            return (
                              <option className="text-dark" key={idx} value={inv._id}>
                                {planName} - {amount.toFixed(2)} {inv.currency}
                              </option>
                            );
                          })
                        ) : null}
                      </select>
                    </div>

                    {/* Edit Investment Form */}
                    <div className="row g-0">
                      <div className="col-md-12">
                        <div className="pb-4">
                          {selectedInvestmentForEdit ? (
                            <div>
                              <div className="d-flex justify-content-between align-items-center mb-4">
                                <h6 className="mb-0">Edit ROI #{selectedInvestmentForEdit.id}</h6>
                              </div>

                              <div className="d-flex gap-4">
                                <div style={{ width: '100%' }}>
                                  {(selectedInvestmentForEdit.roi_distribution || []).map((up, i) => (
                                    <div className="form-group mb-2" key={i}>
                                      <label>Level {up.level} - {up.userDetails?.firstName} {up.userDetails?.lastName} ({up.userDetails?.emailId})</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        onWheel={(e) => e.target.blur()}
                                        value={up.roi_percent}
                                        onChange={e => {
                                          const updated = [...selectedInvestmentForEdit.roi_distribution];
                                          updated[i].roi_percent = e.target.value;
                                          setSelectedInvestmentForEdit({
                                            ...selectedInvestmentForEdit,
                                            roi_distribution: updated
                                          });
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                              <div className="d-flex justify-content-center gap-2 mt-4">
                                <button
                                  className="btn btn-primary"
                                  onClick={async () => {
                                    try {
                                      LoaderHelper.loaderStatus(true);
                                      const payload = {
                                        investmentId: selectedInvestmentForEdit.id,
                                        roi_distribution: (selectedInvestmentForEdit.roi_distribution || []).map(up => ({
                                          level: up.level,
                                          userId: up.user,
                                          percent: parseFloat(up.roi_percent) || 0
                                        })),
                                      };
                                      console.log("🚀 ~ payload for updateAffiliateRoi:", payload);
                                      const response = await AuthService.updateAffiliateRoi(payload);
                                      if (response.success) {
                                        alertSuccessMessage("Investment updated successfully");
                                        loadInvestments(mapReferralUserId);
                                        // setSelectedInvestmentForEdit(null);
                                      } else {
                                        alertErrorMessage(response.message);
                                      }
                                    } catch {
                                      alertErrorMessage("Failed to update investment");
                                    } finally {
                                      LoaderHelper.loaderStatus(false);
                                    }
                                  }}
                                >
                                  Update Changes
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="text-center text-muted py-5">
                              <h6>Select an investment to edit</h6>
                              <p>Choose an investment from the dropdown above to start editing.</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>)}
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => {
                      setMapReferralUserId(null);
                      setSelectedInvestmentForEdit(null);
                      setInvestmentsList([]);
                      setShowInvestmentDetails(false);
                    }}>Cancel</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>



      {/* Modify coin popup */}
      {/* <div class="modal fade show" aria-modal="true" role="dialog" tabindex="-1" style={{ display: "block" }}>
        <div class="modal-dialog application-popup modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add/Remove Fipcoins</h5>
              <button class="btn close">×</button>
            </div>
            <div class="modal-body">
              <div class="container align-items-center">
                <div class="col-6 offset-3 fipcoin-content form-bg">
                  <div class="col-lg-12">
                    <form class="">
                      <div class="contact-form">
                        <div class="row gap-3">
                          <div class="section-field col-12"><p class="mb-0 text-dark text-center">Available Coins : 0 (Fipcoins)</p></div>
                          <div class="section-field col-12"><input name="coins" placeholder="Coins*" type="text" class="require form-control" aria-invalid="false" value="" /></div>
                          <div class="d-flex justify-content-center text-center text-sm-center"><button id="submit" name="submit" type="submit" class="btn btn-primary btn-sm">Add Coins</button></div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-12 fipcoin-content">
                  <table class="table mt-4 table table-bordered">
                    <tr>
                      <th>Date</th>
                      <th>Coins</th>
                      <th>#</th>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* Modify coin popup */}

      {/* update subscription modal */}

      {botSubcriptionUserId && (
        <div className="modal d-block" style={{ background: "#000000a6" }}>
          <div className="modal-dialog application-popup modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Subscription</h5>
                <button className="btn close" onClick={() => setBotSubcriptionUserId(null)}>×</button>
              </div>
              <div className="modal-body">
                <div className="container align-items-center">
                  <div className="col-12 fipcoin-content form-bg">
                    <div className="col-lg-12">
                      <form className="">
                        <div className="contact-form">
                          <div className="row d-flex align-items-center mb-3">
                          </div>
                          <div class="row d-flex align-items-center mb-3">
                            <div class="col-5">Package</div>
                            <div class="section-field col-7">
                              <Select options={packageList} value={selectedPackage} onChange={setSelectedPackage} />
                            </div>
                          </div>
                          <div class="row d-flex align-items-center mb-3">
                            <div class="col-5">From</div>
                            <div class="section-field col-7"><input name="effectiveDate" disabled="" placeholder="Effective Date*" type="date" class="require form-control" aria-invalid="false" value={packageSubscriptionDate.toISOString().split('T')[0]} onChange={(e) => setPackageSubscriptionDate(new Date(e.target.value))} /></div>
                          </div>


                          <div className="modal-footer">
                            <button className="btn btn-secondary" type="button" onClick={() => setBotSubcriptionUserId(null)}>Cancel</button>
                            <button className="btn btn-primary" type="button" onClick={subscribeToBotPackage}>Subscribe</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)}
      {/* update subscription modal */}
    </div>
  ) : (
    <TraderDetails userId={userId} traderData={traderData} />
  );
};

export default TradeList;
